import {Suspense} from 'react'

import type {PreloadableComponent} from './app-routing-types'

export function withLazyAppBoundary(Component: PreloadableComponent): PreloadableComponent {
  const Boundary: PreloadableComponent = () => (
    <Suspense fallback={null}>
      <Component />
    </Suspense>
  )
  Boundary.preload = Component.preload
  Boundary.ssr = Component.ssr
  return Boundary
}
